<template>
  <div class="body"> 
  <div class="container">
    <div class="bigTitleOne" v-scroll-animate="'slide-itemgk'">
      
     

       <div class="chineseA" @click="goGk">
          <a href="/gk" style="color: #333333;">集团简介</a> 
        </div>
        <div class="englishA bounce-element1"> 
          <a href="/gk" >About Us</a>
        </div>

    </div>
    
    <!-- <div class="bigTitleOne wow fadeInDown animated" style="visibility: visible; animation-name: fadeInDown;">新闻动态</div> -->
    <div class="firstCon">
      <div class="oneCon" v-scroll-animate="'fly-in-left5'">
        
        <div class="txt1 modern-ellipsis" v-blank-link v-html="content" @click="goGk"></div> 

      </div>
      <div class="twoCon" v-scroll-animate="'fly-in-right5'">
        <!-- <a> 
          <img :src="rightphoto" alt="" />
        </a>
            -->

            <CarouselHomeyewubankuai ref="carusel0" :imgList="imgList" :heightParam="heightParam" />
            
      </div>
  </div>
  </div>
</div>
</template>

<script>
  import API from '@/api/index'
  import CarouselHomeyewubankuai from '@/components/carousel_home/indexyewubankuai.vue'


export default {
  components: {
    
    CarouselHomeyewubankuai
   },
  data() {
    return {
      // rightphoto: require('@/assets/img2/gaikuang-pic2.jpg'),
      heightParam:'38vw',
      imgList: [
        // {
        //   src: require('@/assets/img2/gaikuang-pic2.jpg'),
        //   line1: ' ',
        //   line2: ' ',
        // },
        {
          src: require('@/assets/8.4/gkPc.jpg'),
          line1: ' ',
          line2: ' ',
        }
      ],
     rightphoto: require('@/assets/8.4/gkPcNotePad.jpg'),
      
      content:""
    }
  },
  created(){
      const { width, height } = window.screen
      const ratio = width / height
      
      // 宽高比大于1.6可能是台式机宽屏
      // 较小的屏幕可能是笔记本
      if (width >= 1920 && ratio > 1.6) {
        // return 'desktop'
       
      } else if (width >= 1440) {
        // return 'laptop'
        this.imgList=[ {
              src: require('@/assets/8.4/gkPcNotePad.jpg'),
              line1: ' ',
              line2: ' ',
            }
          ]
      } else {
        // return 'mobile'
      }
  },
  mounted() {
     
    this.getArticle()    // 获取概括内容
   
   },
  methods: {
    getPlainText(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    },
    goGk(){
        this.$router.push({
          path: '/gk'
        })
      },
      // 获取党建一级页面左侧轮播图
      async getArticle() {
        try {
          let paramsObj={
            catId:'883069b90a844d0499b05fa8e0789079',
            pageNum:1
        }
          const res = await API.getArticle(paramsObj)
           this.content=res.data.artList[0].content
          } catch (error) {
          }
        },
      }
   
}
</script>


<style lang="scss" scoped>
.body{
  background-color: #F4F4F4 ;
  height:45rem;
  @media screen and (max-width: 768px) {
    height:70rem;
  }
}
.container {
  width: 90%;
  margin: 0 auto;
  // padding-top: 7vh;
  position: relative;
  transition: all .4s ease;
  }
  .bigTitleOne {
  font-size: 30px;
  line-height: 6rem;
  color: #333;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 1.2rem;
  }
  // margin-bottom: 3vh;
  }
  .firstCon{
    width:100%;
    height:100%;
    display: flex;
    // background: white;
    @media screen and (max-width: 768px) {
        flex-direction: column;;
      }
   
  }
  .oneCon{
    flex: 50%;
    // width:50%;
    display: inline-block;
    padding:1rem;
    padding-top: 0;
    padding-bottom:0;
    display: flex;
    justify-content: center;
    align-items: center;
    // border-radius:1rem;
    background: #ffffff;
    box-shadow: 0 1px 12px rgba(3, 3, 3, 0.16);

  
    @media screen and (max-width: 768px) {
       width: 100%;
      }
    .txt1{
      
      padding-left:1rem;
      padding-right:1rem;
      // background: red;
      align-items:center;
      // height: 32rem;
      height:auto;
      max-height: 32rem;
      // border:1px solid #f5f5f5ef;
      color: hsl(0, 0%, 20%);
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: justify !important;
      text-justify: inter-ideograph;
      // background: red;
     @media screen and (max-width: 768px) {
        // height:auto !important;
        max-height: 45rem;
      }

     
 
      // white-space: nowrap;
         /* 台式机 (可能更大或比例不同) */
    @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
      // height: 25rem;
    }
      
    }
     // 重置字体样式001
    .txt1 :not(.keep-style) {
      // width: 90%;
      margin: 0 auto !important;
      margin-top: 1rem;
      font-size:1rem !important;
      line-height: 2rem !important; 
      text-indent:2rem !important;
      // text-align: left !important;
      text-align: justify !important;
     
    }
  }
  .twoCon{
    margin-left: 2%;
    width:48vw;
    height: 32rem !important;
       /* 台式机 (可能更大或比例不同) */
       @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
      height: 26rem !important;
    }
    overflow: hidden;
    display: inline-block; 
    @media screen and (max-width: 768px) {
       width: 100%;
       height: 35rem;
      }
    a{
      height: 32rem !important;
      img{
        height: 32rem !important;
        transition: transform 1.5s ease;
        transform: scale(1.1); /* 放大1.1倍 */
      }
    }
    a:hover{
      img{
        transform: scale(1.0); /* 放大1.1倍 */
      }
    }
   
  }
  .el-carousel-item{
      // width:100%;
      height: 100%;
  }
  .carousel-item {
    display: flex; /* 使用Flex布局 */
    height: 100%; /* 确保项目高度为100% */
  }
.tips_newsfont {
  width:100%;
  position: absolute;
  bottom: 0;
  // left: 300px;
  z-index: 5;
  color: #fff;
  @media screen and (max-width: 768px) {
  }
  background: rgba(24, 90, 171, 0.6);
}
.tips_newsfont p{
  padding:2vh 1vh;
  font-size: 1.4vh;
  line-height: 1.8vh;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right:9vh
}
.pic_item{
  width:100%;
    height: 100%;
    object-fit: cover;
}
@keyframes slideInFromLeft {
0% {
  transform: translateX(-100%); /* 元素从左边开始，超出可视区域 */
  opacity: 0; /* 初始时不可见 */
}
100% {
  transform: translateX(0); /* 元素到达正常位置 */
  opacity: 1; /* 完全可见 */
}
}

.first-left {
// animation: slideInFromLeft 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，结束后保持最终状态 */
}
/*指示器*/
.first-left .el-carousel__indicators {
left: unset;
transform: unset;
right: 2%;
bottom:2.4%
}
/*指示器按钮*/ 


.first-left .el-carousel__button {
 width: 1vh;
height: 1vh;
border: none;
border-radius: 50%;
background-color: #fff;
}
/*指示器激活按钮*/
.first-left .is-active .el-carousel__button {
background: #015293;
}

.first-left .el-carousel__container {
height: 100%;
}
@keyframes slideInFromRight {
0% {
  transform: translateX(100%); /* 元素从左边开始，超出可视区域 */
  opacity: 0; /* 初始时不可见 */
}
100% {
  transform: translateX(0); /* 元素到达正常位置 */
  opacity: 1; /* 完全可见 */
}
}

.content-news {
// animation: slideInFromRight 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，结束后保持最终状态 */
}
.content-news{
  height: 48vh;
  padding-top:1vh;
  overflow-y: hidden;
  background-color: #fff;
 
  @media screen and (max-width: 768px) {
    height: 50vh;
  }

}
.list-news{
  // height:16vh;
  padding:1rem 1rem 0.6rem 2rem;
  // padding-bottom: 0;
  overflow: hidden; /* 关键属性：隐藏超出部分 */
  // border-bottom: 1px solid #eee;
  color: #333333;

}
.list-news:hover {
  background-color: #015293;
  color: white; /* 注意：背景颜色通常不应用于链接，除非你有特定的背景容器 */
}
// .list-news:hover div{
//   background-color: #015293!important;
//   color: white; /* 注意：背景颜色通常不应用于链接，除非你有特定的背景容器 */
// }
.list-news:last-child{
  border-bottom:none;

}
.news-title{
  font-size: 1.1rem;
  // margin-bottom: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media screen and (max-width: 768px) {
    font-size: 1rem;
  }
}
.news-detail{
  height: 4.4vh; /* 假设行高大约是1.2em */
  overflow: hidden;
  // padding-top:5px;
  background-color: none!important;

}
:v-deep .news-detail p{
  background-color:transparent !important;
  font-size: 1.2vw!important;
  line-height:1.2vw!important;
  // margin-bottom: 1vh;
   
}
:v-deep .news-detail p span{
  all:unset;
  font-size: 1.2vw!important;
  line-height: 1.2vw!important;
  background-color: none!important;
  
}
.news-detail p span{
  @media screen and (max-width: 768px) {
    font-size: 1rem !important;
  }
}


:v-deep .news-detail p span span{
  all:unset;
  font-size: 1.2vh!important;
  line-height:1.2vw!important;
  background-color: none!important;
  color:red;
 
}
.news-detail p{
  background-color:transparent !important;
}
:v-deep  .news-detail p{
  font-size: 1.2vh!important;
  line-height:1.2vw!important;
 
}



.news-time{
  padding-top:1vh;
  font-size: 0.9rem;
  white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
</style>
  <style lang="scss" scoped> 
  .container {
    min-height: 78vh !important;
    padding-top: 5vh !important;
    position: relative;
    transition: all .4s ease;
    @media screen and (max-width: 768px) {
        padding-top: 0vh !important;
        min-height: 50vh !important;
      }
  }
  .Hcssy{
    height: 48vh;
    @media screen and (max-width: 768px) {
      height: 26vh;
    }
  }
  .newCss0{
    clear: both;
    font-size: 2.5vh;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      font-size: 2vh;
    }
  }
  .dotSpan::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: #3498db;
    border-radius: 50%;
  }
  .timeSpan{
    font-size: 0.9rem;
    color: #999999;
  }
  .twoCon{
    // border: 1px solid #f00;
    img{
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }
  ::v-deep .carousel_wrap .el-carousel__item img{
    height: 32rem !important;
      /* 台式机 (可能更大或比例不同) */
      @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
      height: 26rem  !important;
    }
    @media screen and (max-width: 768px) {
      width: 96% !important;
      height:30rem !important
    }
  }
  ::v-deep .el-carousel__container{
    @media screen and (max-width: 768px) {
      width: 96% !important;
      height:65rem !important
    }
  }

  .modern-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 15;
   /* 台式机 (可能更大或比例不同) */
 @media screen and (min-width: 1920px),
    screen and (min-width: 1600px) and (min-aspect-ratio: 16/10) {
      -webkit-line-clamp: 15;
    }
   @media screen and (max-width: 768px) {
      // -webkit-line-clamp: 15;
    }
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  
  /* 处理内部元素 */
  > * {
    display: inline; /* 强制内联显示 */
    white-space: normal;
  }
}

  </style>